// extracted by mini-css-extract-plugin
export default {"page-break":"PageBreak_page-break__mFvXV"};